import { render } from "./ChevronRightIcon.vue?vue&type=template&id=1c7dd930"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__